import React from 'react';
import { hashHistory   } from 'react-router';
import FlatButton from 'material-ui/FlatButton';


export default class HeaderUnauthorized extends React.Component {

     constructor(props) {
        super(props);

        this.handleBack = this.handleBack.bind(this);
    }

    handleBack(){
        
        if(this.props.useBackFunction) {
            hashHistory.goBack();
        }
        else{
          hashHistory.push('/');
        }

    }

    render() {

        var linkText = "Cancel"

        if(this.props.useBackFunction) {
            linkText = "Back"
        }

        return (
            
            <header className="headerUnauthorized">
                <div style={{padding: "7px 0 7px 0" }} >
                <table>
                    <tbody>
                        <tr>
                            <td style={{width:'18%', paddingTop:10}} >
                                
                            <FlatButton
                                    label={linkText}
                                    labelStyle={{fontSize: 16, color:'#fff',  textTransform: 'none'}}
                                    onClick={this.handleBack}                                
                                />
                            </td>
                            {/*containerElement={<Link to={"/"} />}*/}
                            <td>
                                {(this.props.children) && (
                                    <div style={{textAlign:'center', marginTop:15}} >
                                    <p>
                                        { this.props.children }
                                    </p>
                                    </div>
                                )}
                            </td>
                            <td style={{width:'18%', textAlign: 'center'}}>
                                
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
               
            </header>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Header/HeaderUnauthorized.js